import React from 'react';
import { IonInput } from '@ionic/react';

type Props = { value?: number | null; onChange: (value: number | null) => void; label: string; disabled?: boolean; description?: string };
export default function LimiteOpcaoEditor({ value, onChange, label, disabled, description }: Props) {
  return <div className="catalogo-field" style={{ marginTop: 8 }}>
    <label className="catalogo-field-label">Máximo desta opção por produto (opcional)</label>
    <IonInput className="catalogo-field-input" type="number" min="1" step="1" disabled={disabled}
      aria-label={label} placeholder="Usar limite do grupo" value={value ?? ''}
      onIonChange={event => onChange(event.detail.value === '' || event.detail.value == null ? null : Number(event.detail.value))} />
    {description && <p className="catalogo-toggle-desc">{description}</p>}
  </div>;
}
